module.exports = __webpack_public_path__ + "static/media/piriArtworkBg_blur.9c1e268d.JPG";